import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { deepPure } from '~/util';
import WeekViewSvg from './Images/WeekView.svg';
import MonthViewSvg from './Images/MonthView.svg';
import QuarterViewSvg from './Images/QuarterView.svg';
import YearViewSvg from './Images/YearView.svg';
import DayViewSvg from './Images/DayView.svg';
import { ChartRangeItem2 } from './ChartRangeItem2';

const useStyles = makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  },
  itemContainer: {
    borderRight: `1px solid ${theme.palette.grey[400]}`
  },
  totalContainer: { borderLeft: `1px solid ${theme.palette.grey[400]}` },
  openButton: {},
  timeContainer: {},
  timeContainerFixedRange: {},
  timeContainerDay1: {},
  timeContainerDay2: {},
  timeContainerDay3: {},
  timeContainerDay4: {},
  timeContainerDay5: {},
  timeContainerDay6: {},
  timeContainerDay7: {},
  timeContainerYear: {
    background: `url(${YearViewSvg})`
  },
  timeContainerQuarter: {
    background: `url(${QuarterViewSvg})`,
    backgroundPositionX: 1,
    backgroundPositionY: 0
  },
  timeContainerMonth: {
    background: `url(${MonthViewSvg})`
  },
  timeContainerWeek: {
    background: `url(${WeekViewSvg})`
  },
  timeContainerDay: {
    background: `url(${DayViewSvg})`
  }
}));

export const StyledChartRangeItem2 = ({
  classes: classesOverrides,
  ...props
}) => {
  const classes = useStyles({ classes: classesOverrides });

  return <ChartRangeItem2 {...props} classes={classes} />;
};

StyledChartRangeItem2.propTypes = {
  classes: PropTypes.object,
  props: PropTypes.object
};

export default deepPure(StyledChartRangeItem2);
